<div class="table-container">
    <table class="table is-hoverable is-fullwidth">
        <thead>
            <tr>
                <th>E-Mail</th>
                <th style="text-align: center">Status ({{this.completed}}/{{invites.length}})</th>
                <th style="text-align: center">Aktion</th>
            </tr>
        </thead>
        <tbody style="height: 100px;">
            <tr *ngFor="let invite of invites; let i = index">
                <td>{{invite.mail}}</td>
                <td>
                    <div class="led"
                         [class.is-green]="invite.status === 'COMPLETE'"
                         [class.is-yellow]="invite.status === 'PENDING'"
                         [class.is-red]="invite.status === 'EXPIRED' || invite.status === 'INVALID'">
                    </div>
                </td>
                <td style="text-align: center !important;" class="space-items-evenly">
                    <button (click)="renewInvite(invite)" [disabled]="invite.status !== 'EXPIRED'" class="button is-darkblue is-full is-small is-rounded">Erneuern</button>
                    <button (click)="deleteInvite(invite)" class="button is-danger is-full is-small is-rounded">Löschen</button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
